import React, { Component } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { media } from "utils/media";
import mdToHtml from "../utils/mdToHtml";
import { Button, Image, Link, Slideshow } from "components";
import { routes } from "utils/routes";

class SectionResultsQuote extends Component {
  constructor(props) {
    super(props);
    if (!this.props.content.enabled) return false;
    this.state = { active: 0 };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(newActive) {
    const maxIdx = this.props.content.testimonialBlocks.length - 1;
    let newIdx = newActive < 0 ? maxIdx : newActive;
    newIdx = newActive > maxIdx ? 0 : newIdx;
    this.setState({ active: newIdx });
  }

  render() {
    const { noButton, className } = this.props;
    const { active } = this.state;

    return (
      <div className={cx("section-results", [className])}>
        <h2 className="section-title">{this.props.content.title}</h2>
        <div className="results-mobile-wrapper">
          <Slideshow
            slidesPerPage={1}
            onChange={this.handleChange}
            value={active}
          >
            {this.props.content.testimonialBlocks.map(
              ({ image, name, text, title }, i) => (
                <div key={i} className="results-wrapper">
                  <div className="section-media">
                    <div className="media-wrapper">
                      <Image url={media(image)} alt={name} />
                    </div>
                  </div>
                  <div className="section-text">
                    <div className="quotes-wrapper">
                      <blockquote>
                        <h4>{name}</h4>
                        <h3 className="mb-20">{title}</h3>
                        <div
                          dangerouslySetInnerHTML={{ __html: mdToHtml(text) }}
                        />
                      </blockquote>
                    </div>
                  </div>
                </div>
              )
            )}
          </Slideshow>
          <div className="quotes-nav">
            <Button
              label="previous"
              onClick={() => this.handleChange(active - 1)}
              className="button-quotes-prev"
              aria-label="Previous quote"
            />
            <Button
              label="next"
              onClick={() => this.handleChange(active + 1)}
              className="button-quotes-next"
              aria-label="Next quote"
            />
          </div>
          {!noButton && (
            <Link
              to={routes.results.path}
              {...routes.results}
              className="button outline"
            >
              See more results
            </Link>
          )}
        </div>

        <div className="results-wrapper hide-mobile">
          <div className="section-media">
            {this.props.content.testimonialBlocks.map(({ image, name }, i) => (
              <div
                key={i}
                className={cx("media-wrapper", { active: active === i })}
              >
                <Image url={media(image)} alt={name} />
              </div>
            ))}
          </div>
          <div className="section-text">
            <div className="quotes-wrapper">
              {this.props.content.testimonialBlocks.map(
                ({ author, name, text, title }, i) => (
                  <blockquote key={i} className={cx({ active: active === i })}>
                    <h4>{name}</h4>
                    <h3 className="mb-20">{title}</h3>
                    <div dangerouslySetInnerHTML={{ __html: mdToHtml(text) }} />
                  </blockquote>
                )
              )}
            </div>
            <div className="quotes-nav">
              <Button
                label="previous"
                onClick={() => this.handleChange(active - 1)}
                className="button-quotes-prev"
                aria-label="Previous quote"
              />
              <Button
                label="next"
                onClick={() => this.handleChange(active + 1)}
                className="button-quotes-next"
                aria-label="Next quote"
              />
            </div>
            {!noButton && (
              <Link
                to={routes.results.path}
                {...routes.results}
                className="button outline"
              >
                See more results
              </Link>
            )}
          </div>
        </div>
      </div>
    );
  }
}

SectionResultsQuote.propTypes = {
  noButton: PropTypes.bool.isRequired,
  className: PropTypes.string.isRequired,
  content: PropTypes.object.isRequired,
};

SectionResultsQuote.defaultProps = {
  noButton: false,
  className: "",
  content: {},
};

export default SectionResultsQuote;
